import { h } from './index-e1ee5b28.js';
import { j as splitTextForScreenReader } from './helpers-01739d22.js';

const MenuToggle = (props) => {
    const { translations: t, expanded, label, labelExpanded, ref } = props;
    const showMenuTpl = label || t.html('showMenu');
    const closeMenuTpl = labelExpanded || t.html('closeMenu');
    const formatter = (text, isSR) => h("span", { class: { 'sr-only': isSR } }, text);
    return (h("button", { class: "menu-toggle", type: 'button', "aria-expanded": (!!expanded).toString(), ref: ref },
        h("span", { class: "menu-toggle-text" }, splitTextForScreenReader(showMenuTpl, formatter)),
        h("span", { class: "menu-toggle-text-expanded" }, splitTextForScreenReader(closeMenuTpl, formatter)),
        h("span", { class: "menu-toggle-icon" })));
};

export { MenuToggle as M };

//# sourceMappingURL=MenuToggle-e021f8c5.js.map